import routerOptions from "./router.options";
import coreRoutes from "./_core.routes";

// Public
import login from "./login.routes";

// Admin
import homeRoutes from "./home.routes";
import users from "./users.routes";
import usersGroups from "./users-groups.routes";
import dataSources from "./data-sources.routes";
import categories from "./categories.routes";
import workspaces from "./workspaces.routes";
import reports from "./reports.routes";

// Hooks
import afterEach from "./hooks/after-each.hooks";
import beforeEach from "./hooks/before-each.hooks";
import beforeResolve from "./hooks/before-resolve.hooks";

const routes = [
  // Public
  ...login,

  // Admin
  ...homeRoutes,
  ...users,
  ...usersGroups,
  ...dataSources,
  ...categories,
  ...workspaces,
  ...reports,

  ...coreRoutes, // (!) Always last
];

const hooks = {
  afterEach,
  beforeEach,
  beforeResolve,
};

export { hooks, routerOptions, routes };
